module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M4.889 9.998c-.554 0-1.224.472-1.496.96L.158 16.787c-.272.488-.188 1.234.19 1.644L1.8 20.025c.376.41 1.11.614 1.64.454l3.259-.998 2.813 2.885 2.813 2.865-1.09 3.303c-.176.528.028 1.248.45 1.606l1.816 1.542c.424.358 1.158.428 1.642.158l5.895-3.257c.484-.272.958-.944.958-1.502v-7.482c9.997-5.409 9.956-15.484 9.956-18.507 0-.558-.482-1.09-1.04-1.09-3.015 0-12.385 0-18.585 9.998H4.891zm20.073.011c-1.664 0-3.011-1.344-3.011-2.999s1.348-2.999 3.011-2.999 3.011 1.344 3.011 2.999-1.348 2.999-3.011 2.999z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/rocket-1.js
// module id = 1394
// module chunks = 14